import { Pipe, PipeTransform } from '@angular/core';
import { withDecimals } from '../utils/utils';

@Pipe({
  name: 'decimals',
  standalone: true
})
export class DecimalsPipe implements PipeTransform {
  transform(value: number | string | null | undefined, currencySymbol?:string): string {
    if (value === null || value === undefined || value === '' || Number.isNaN(Number(value))) {
      return '0.00';
    }
    
    return withDecimals(value);
  }
}
